/* eslint-disable max-len */
import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'interfaces';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state['feature/base/auth'] || initialState;

export const selectLoader = createSelector([selectDomain], (authState) => authState.loading);
export const selectActionLoader = createSelector([selectDomain], (authState) => authState.actionLoading);
export const selectAccessToken = createSelector(
  [selectDomain],
  (SighInState) => SighInState.accessToken,
);
export const selectAuth = createSelector([selectDomain], (authState) => authState);
export const selectAuthUser = createSelector([selectDomain], (authState) => authState.authUser);
export const selectSponsorContent = createSelector([selectDomain], (authState) => authState.authUser.attributes.sponsorContent);
export const selectAchievements = createSelector([selectDomain], (authState) => authState.authUser.attributes.achievements);
export const selectStatistics = createSelector([selectDomain], (authState) => authState.authUser.attributes.statistics);
export const selectBadges = createSelector([selectDomain], (authState) => authState.authUser.attributes.badges);
export const selectStripeConnectUrl = createSelector([selectDomain], (authState) => authState.authUser.attributes.stripeAccountUrl);
export const selectStripeAccountCompleted = createSelector([selectDomain], (authState) => authState.authUser.attributes.stripeAccountCompleted);
export const selectStripePayoutEnabled = createSelector([selectDomain], (authState) => authState.authUser.attributes.stripePayoutsEnabled);
export const selectStripeConnectAlertClosed = createSelector([selectDomain], (authState) => authState.stripeConnectAlertClosed);
export const selectCallbackPath = createSelector([selectDomain], (authState) => authState.callbackPath);
